import { render, staticRenderFns } from "./passwordChanged.vue?vue&type=template&id=d0354e12&"
import script from "./passwordChanged.vue?vue&type=script&lang=js&"
export * from "./passwordChanged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports